<rw-modal
  modalId="userPackageChangeModal"
  datapendoid="user-package-change-modal"
  datatestid="user-package-change-modal"
  [title]="'Change Packages'"
  arialabel="Change Packages"
  [dismissible]="false"
  size="xl"
  #modalRef
  [hidden]="hideModal"
>
  <div modal-body>
    <div class="row flex-shrink-0">
      <div class="col-6">
        @if (showPkgSubtextSection) {
        <div>
          <br />
          <h5 class="sectionTitle">{{ partnerName }} Packages</h5>
          <div class="packages-subtext">
            <span [innerHtml]="wlpPackageText"></span>
          </div>
        </div>
        }
      </div>
      <div class="col-6 shopping-cart">
        <div #cartIcon class="pull-right">
          <app-shopping-cart-icon (ToggleShoppingCart)="toggleShoppingCart()"></app-shopping-cart-icon>
        </div>
        <div #cart>
          @if (isShoppingCartVisible) {
          <app-shopping-cart
            [PaymentInfo]="paymentInfo"
            [IsInline]="false"
            (CloseCart)="toggleShoppingCart()"
          ></app-shopping-cart>
          }
        </div>
      </div>
    </div>
    <div class="row manage-packages-content">
      <div class="col-12">
        @if(componentLoading()) {
        <rw-spinner
          datapendoid="user-package-change-modal-assignpackage-spinner"
          datatestid="user-package-change-modal-assignpackage-spinner"
          spinnerclass="rw-spinner-primary"
          size="lg"
        >
        </rw-spinner>
        } @else { @if(!showOldPackageOptionsStep) {
        <app-change-package
          data-id="appChangePackage"
          [packageSelectForm]="packagesForm"
          [OrganizationID]="organizationId"
          [orgProfile]="orgProfile"
          [orgConfig]="orgConfig"
          [userData]="userData"
          [orgWlpContactInfo]="orgWlpContactInfo"
          (PackageSelected)="packageSelected($event)"
          (PackagesLoaded)="packagesLoaded()"
          [CheckForInitialActiveMessage]="checkForInitialActiveMessage"
          [AssignedPackage]="assignedPackage"
          [hideTitles]="true"
        ></app-change-package>
        } @else {
        <app-user-package-change-options
          [config]="userPackageChangeOptionsConfiguration"
          #userPackageChangeOptionsComponent
          (keepOldPackageOptionSelected)="onKeepOldPackageOptionSelected($event)"
        ></app-user-package-change-options>
        } }
      </div>
    </div>
  </div>

  <div modal-footer>
    <div class="d-flex flex-wrap gap-2">
      <rw-button
        id="cancelButton"
        (clickButton)="close()"
        buttonclass="rw-btn-secondary"
        text="Cancel"
        arialabel="Cancel"
        datapendoid="apphub-user-package-change-cancel-button"
        datatestid="apphub-user-package-change-cancel-button"
      >
      </rw-button>
      <rw-button
        id="saveButton"
        [disable]="!canSubmit()"
        (clickButton)="saveChanges()"
        buttonclass="rw-btn-primary"
        text="Save"
        arialabel="Save"
        datapendoid="apphub-user-package-change-save-button"
        datatestid="apphub-user-package-change-save-button"
      >
      </rw-button>
    </div>
  </div>
</rw-modal>
<app-confirmation-modal
  dialogTitle="Are you sure you want to leave?"
  dialogMessage="You haven't saved your changes yet, and you will lose them if you leave."
  confirmButtonText="Leave"
  (confirmClicked)="confirmLeavePage()"
  (cancelClicked)="cancelLeavePage()"
  #confirmationModalRef
></app-confirmation-modal>
